<template>
	<div class="card" style="height: 400px;">
		<h1>{{$t('VideoHighlights')}}</h1>
		<iframe v-if="validVideoPlatform" :src="parsedVideoUrl" allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen" frameBorder="0" width="100%" height="84%"></iframe>
		<div v-else-if="!validVideoPlatform && parsedVideoUrl" class="video-box">
			<Button icon="pi pi-video" style="fontSize: 2rem;" @click="commonService.openNewTab(parsedVideoUrl)" />
		</div>
		<div v-else class="video-box">
			{{$t('NoVideo')}}
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	props: ["videoUrl"],
	data: function () {
		return {
			validVideoPlatform: null,
		};
	},
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	computed: {
		parsedVideoUrl: {
			get() {
				function parseVimeoUrl(url) {
					var vimeoRegex = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
					var parsed = url.match(vimeoRegex);
					return "//player.vimeo.com/video/" + parsed[1];
				}

				if (this.videoUrl != null) {
					this.validVideoPlatform = true;

					if (this.videoUrl.includes("vimeo"))
						return parseVimeoUrl(this.videoUrl);

					if (this.videoUrl.includes("instagram")) {
						var url = this.videoUrl.split("?")[0];
						return url.slice(-1) == "/"
							? url + "embed"
							: url + "/embed";
					}

					if (this.videoUrl.includes("you")) {
						if (this.videoUrl.includes("channel")) {
							this.validVideoPlatform = false;
							return this.videoUrl;
						}

						if (this.videoUrl.includes("user")) {
							this.validVideoPlatform = false;
							return this.videoUrl;
						}

						//youtube
						let url = this.videoUrl.replace(
							"&feature=youtu.be",
							""
						);
						if (url.includes("youtu.be"))
							return url.replace(
								"youtu.be",
								"www.youtube.com/embed"
							);
						if (url.includes("m.youtube.com"))
							return url
								.replace(
									"m.youtube.com/watch?v=",
									"www.youtube.com/embed/"
								)
								.split("&")[0];
						else
							return url
								.replace("watch?v=", "embed/")
								.split("&")[0];

						return url;
					}

					this.validVideoPlatform = false;
					return this.videoUrl;
				}

				this.validVideoPlatform = false;
				return null;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.video-box {
	border: 1px solid #b3c2ca;
	height: 325px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>